export default {
  zh: {
    plexVpn: 'Plex加速器',
    loginText: '登 录',
    registerText: '注 册',
    logging: '登录中,请稍后'
  },
  en: {
    plexVpn: 'PlexVPN',
    loginText: 'Log In',
    registerText: 'Register',
    logging: 'Logging, please wait'
  }
}



// WEBPACK FOOTER //
// ./src/views/auth/loginRegister/lang.js